import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    filtrosAplicados: [],
    establecimientos: [],
    region: null,
    comuna: null,
    nombreBusqueda: "",
    nivel: null,
    paginaActual: 1,
    vista: MODO_SHINNY_VACANTES ? "mapa" : "detalle"
  },
  getters: {
    getFiltros(state) {
      return state.filtrosAplicados;
    },
    getEstablecimientos(state) {
      return state.establecimientos;
    }
  },
  actions: {
    setFiltros({ commit }, payload) {
      commit("cambiarFiltros", payload);
    },
    setEstablecimientos({ commit }, payload) {
      commit("cambiarEstablecimientos", payload);
    },
    setRegion({ commit }, payload) {
      commit("cambiarRegion", payload);
    },
    setComuna({ commit }, payload) {
      commit("cambiarComuna", payload);
    },
    setNombre({ commit }, payload) {
      commit("cambiarNombre", payload);
    },
    setNivel({ commit }, payload) {
      commit("cambiarNivel", payload);
    },
    setPagina({ commit }, payload) {
      commit("cambiarPagina", payload);
    },
    setVista({ commit }, vista) {
      commit("cambiarVista", vista);
    }
  },
  mutations: {
    cambiarFiltros(state, payload) {
      state.filtrosAplicados = [...payload];
    },
    cambiarEstablecimientos(state, payload) {
      state.establecimientos = [...payload.establecimientos];
    },
    cambiarRegion(state, payload) {
      state.region = payload.region;
    },
    cambiarComuna(state, payload) {
      state.comuna = payload.comuna;
    },
    cambiarNombre(state, payload) {
      state.nombreBusqueda = payload.nombre;
    },
    cambiarNivel(state, payload) {
      state.nivel = payload.nivel;
    },
    cambiarPagina(state, payload) {
      state.paginaActual = payload.pagina;
    },
    cambiarVista(state, vista) {
      state.vista = vista;
    }
  }
});

export default store;



// WEBPACK FOOTER //
// ./src/store/store.js